import React from "react";
import PropTypes from "prop-types";
import { graphColors } from "utils/styles";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from "recharts";

const ScoreDistributionChart = ({ scoreDistribution }) => {
  if (!scoreDistribution || Object.keys(scoreDistribution).length === 0) {
    return (
      <div className="graph-container">
        <h4 className="graph-header">Score Distribution</h4>
        <div className="no-data-message">No score data available</div>
      </div>
    );
  }

  const sortOrder = ["0-59%", "60-74%", "75-89%", "90-100%"];
  const data = sortOrder
    .filter(key => scoreDistribution[key] !== undefined)
    .map((key) => ({
      range: key,
      count: scoreDistribution[key]
    }));

  if (data.length === 0) {
    const unsortedData = Object.entries(scoreDistribution).map(([key, value], i) => ({
      range: key,
      count: value,
      fill: graphColors[i % graphColors.length]
    }));
    data.push(...unsortedData);
  }

  return (
    <div className="graph-container">
      <h4 className="graph-header">Score Distribution</h4>
      <ResponsiveContainer height={250}>
        <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="range" />
          <YAxis />
          <Tooltip
            formatter={(value) => [value, "Calls"]}
          />
          <Bar dataKey="count" fill={graphColors[0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

ScoreDistributionChart.propTypes = {
  scoreDistribution: PropTypes.object
};

export default ScoreDistributionChart;
